import { Info } from "lucide-react";
import type { Project } from "@/domain/types";

// ZEUS-135 — persistent banner shown exactly when a project is in draft or
// review, worded per spec: operational work continues, only metadata is
// pending. Appears only for these two statuses — published/active/planned/
// closed render nothing (the parent should just not see a gap, not a banner
// saying "this project is fine").
const BANNER_BODY: Partial<Record<Project["status"], string>> = {
  draft: "This project is currently in Draft mode. Operational work can continue. Metadata changes are pending approval.",
  review: "This project is currently in Review mode. Operational work can continue. Metadata changes are pending approval.",
};

export function ProjectStatusBanner({ status }: { status: Project["status"] }) {
  const body = BANNER_BODY[status];
  if (!body) return null;

  return (
    <div className="mt-5 flex items-start gap-3 rounded-md border border-line bg-subtle/60 px-4 py-2.5 text-sm text-mute">
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-faint" />
      <span>{body}</span>
    </div>
  );
}
